import _http from './ipv6_http.js';
const host = window.location.host;
let baseURL = getTopDomain(`https://${host}`, 'ipv6');
const http = _http.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  baseURL
});

export const getIpv6Api = (params) => {
  return http({
    url: '/getip',
    method: 'post',
    data: params
  });
};

function getTopDomain(url, secondDomain) {
  try {
    const domain = url.replace(/^https?:\/\//, '').split('/')[0];
    const domainParts = domain.split('.');
    const baseDomain = domainParts.slice(domainParts.length - 2).join('.');
    const newDomain = 'https://' + secondDomain  + '.' + baseDomain;
    return newDomain 
  } catch (error) {
    return 'https://' + secondDomain  + '.' + 'leteng5.cn';
  }
}